import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook pentru a seta lang attribute dinamic pe <html> bazat pe limba curentă
 * Îmbunătățește SEO și accesibilitatea pentru conținut multi-limbă
 */
export const useLangAttribute = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Setează lang attribute pe <html> element
    const currentLang = i18n.language || 'ro';
    const langCode = currentLang === 'en' ? 'en' : 'ro';
    
    // Actualizează lang attribute
    document.documentElement.lang = langCode;
    
    // Adaugă și dir attribute pentru limbi RTL (dacă e necesar în viitor)
    // document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';

    // Cleanup nu este necesar, dar putem adăuga dacă e cazul
    return () => {
      // Lang attribute rămâne setat, nu trebuie resetat
    };
  }, [i18n.language]);
};


























